import Button from "@pathwright/ui/src/components/button/Button"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import Tooltip from "@pathwright/ux/src/components/tooltip/Tooltip"
import { TFunction } from "i18next"
import styled from "styled-components"
import { NotificationNode } from "../../../notifications/state/hooks"
import { useReviewContext } from "../../state/ReviewContextProvider"
import { TreeNode } from "../../state/tree/path-tree"
import {
  usePanelQueryParm,
  useUserAskedToRespondNotificationsForItem
} from "../../utils"

export function getResponseCountStr(t: TFunction, responseCount: number) {
  return t("{{ count }} response", {
    defaultValue_plural: "{{ count }} responses",
    count: responseCount
  })
}

export function getShareFeedbackStr(notification: NotificationNode) {
  // @ts-expect-error: Need to test out the meta typing.
  return `${notification.meta.user} asked you to share feedback.`
}

const StyledButton = styled(Button)`
  .CountIndicator {
    right: -0.35em !important;
  }
`

function FeedbackResponses({ item }: { item: TreeNode<"completion"> }) {
  const { completion } = item.data
  const { t } = useTranslate()
  const {
    actions: { select, getItem }
  } = useReviewContext()
  const { notifications } = useUserAskedToRespondNotificationsForItem(item)
  const notification = notifications[0]

  const setSelectedPanel = usePanelQueryParm()

  const totalResponses =
    completion.feedback_discussion_context?.num_responses || 0

  const tooltip = notification
    ? getShareFeedbackStr(notification)
    : getResponseCountStr(t, totalResponses)

  return totalResponses || notification ? (
    <span>
      <Tooltip title={tooltip} portal={false} fitContent>
        <StyledButton
          styleType="inline"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation()
            setSelectedPanel("discuss")
            select(getItem(item.id)!)
          }}
          icon="chat-bubbles"
          label={totalResponses || null}
          size="large"
          indicator={!!notification}
        />
      </Tooltip>
    </span>
  ) : null
}

export default FeedbackResponses
